import { useTranslation } from 'react-i18next'
import { columnsFor, defaultColumns } from './columnDefs'
import { Popover } from './parts'
import type { LinkKind } from './types'

/** "Columns (9/15)": which optional columns this viewer sees on this tab. */
export function ColumnsPicker({ kind, value, onChange }: { kind: LinkKind; value: string[]; onChange: (ids: string[]) => void }) {
  const { t } = useTranslation('trackingLinks')
  const all = columnsFor(kind)
  const shown = all.filter((c) => value.includes(c.id))
  const toggle = (id: string) => onChange(value.includes(id) ? value.filter((x) => x !== id) : all.map((c) => c.id).filter((x) => value.includes(x) || x === id))
  return (
    <Popover icon="columns" label={t('columns.button', { shown: shown.length, total: all.length })}>
      {() => (
        <div className="tl-colpick">
          <div className="tl-colpick-head">
            <button type="button" className="dl-link" onClick={() => onChange(all.map((c) => c.id))}>{t('columns.all')}</button>
            <button type="button" className="dl-link" onClick={() => onChange(defaultColumns(kind))}>{t('columns.defaults')}</button>
          </div>
          {all.map((c) => (
            <label key={c.id} className="dl-check" title={t(`colHelp.${c.id}`)}>
              <input type="checkbox" checked={value.includes(c.id)} onChange={() => toggle(c.id)} />
              {t(`col.${c.id}`)}
            </label>
          ))}
        </div>
      )}
    </Popover>
  )
}

/** "How it works": one line per column, in the glossary's words. */
export function HowItWorks({ kind, repliesSince }: { kind: LinkKind; repliesSince: string | null }) {
  const { t } = useTranslation('trackingLinks')
  return (
    <Popover icon="help-circle" label={t('how.button')} align="right">
      {() => (
        <div className="tl-how">
          <p className="dl-hint">{t(kind === 'trial' ? 'how.introTrial' : 'how.intro')}</p>
          <dl>
            {['fans', ...columnsFor(kind).map((c) => c.id).filter((id) => id !== 'fans' && id !== 'updated')].map((id) => (
              <div key={id}>
                <dt>{t(`col.${id}`)}</dt>
                <dd>{t(`colHelp.${id}`, { since: repliesSince ?? '' })}</dd>
              </div>
            ))}
          </dl>
          <p className="dl-hint">{t('how.range')}</p>
        </div>
      )}
    </Popover>
  )
}
